import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  count: 0,
};

const pendingUsersSlice = createSlice({
  name: "pendingUsers",

  initialState,

  reducers: {
    setPendingUserCount: (state, action) => {
      state.count = Number(action.payload) || 0;
    },

    clearPendingUserCount: (state) => {
      state.count = 0;
    },
  },
});

export const {
  setPendingUserCount,
  clearPendingUserCount,
} = pendingUsersSlice.actions;

export default pendingUsersSlice.reducer;